
<template>
  <div>
    <VPopup
      not-hide-on-click
      closable
      show-pointer
      class="position-details-popup"
      position="bottom"
      :visible="visible"
      :target="target"
      @close="closePopup"
    >
      <template v-if="demandV2">
        <DemandV2OptionsSection
          :demand-v2="demandV2"
          hide-create-option
          @DemandOption:created="$emit('renew-data')"
          @DemandOption:updated="$emit('renew-data')"
          @DemandOption:deleted="$emit('renew-data')"
        />
 
        <DemandV2PrevDealsSection
          :demand-v2="demandV2"
        />
      </template>
    </VPopup>
  </div>
</template>
 
<style lang="scss" src="./DemandV2PrevDealsPopup.scss" />
 
<script lang="ts">
 
import DemandV2OptionsSection   from '@/domains/DemandsV2/components/DemandV2Card/DemandV2OptionsSection.vue';
import DemandV2PrevDealsSection from '@/domains/DemandsV2/components/DemandV2Card/DemandV2PrevDealsSection.vue';
import DemandV2                 from '@/domains/DemandsV2/DemandV2';
 
export default defineComponent({
  name: 'DemandV2PrevDealsPopup',
 
  components: {
    DemandV2OptionsSection,
    DemandV2PrevDealsSection,
  },
 
  props: {
    target: {
      type:    [String, HTMLElement, Object] as PropType<string | HTMLElement | null>,
      default: null,
    },
    visible: {
      type:    Boolean,
      default: false,
    },
    /** Потребность, по которой показываем варианты и прошлые сделки.
     *  Прежнее имя (position) осталось от старой сущности и вводило в
     *  заблуждение: здесь никогда не было позиции заказа. */
    demandV2: {
      type:    DemandV2,
      default: null,
    },
  },
 
  emits: ['close', 'renew-data'],
 
  methods: {
    closePopup(): void {
      this.$emit('close');
    },
  },
});
</script>